



import { BaseEntityResponse } from '@m4u-angular/base/entities/BaseEntities';
import { BaseEntitiesResponse } from '@m4u-angular/base/entities/BaseEntities';
import { BaseDataResponse } from '@m4u-angular/base/entities/BaseEntities';
import { BaseResponse } from '@m4u-angular/base/entities/BaseEntities';
import { GenericListEntity } from '@m4u-angular/base/entities/BaseEntities';
import { DataGroupInfo } from '@m4u-angular/base/entities/BaseEntities';
import { BaseEndpoint } from '@m4u-angular/base/endpoint/BaseEndpoint';
import { BaseEndpointCRUD } from '@m4u-angular/base/endpoint/BaseEndpointCRUD';
import { DataLoadOptions } from '@m4u-angular/base/datalayer/DataLoadOptions';
import { APIGatewayService } from '@m4u-angular/core/gateway/APIGateway.service';
import { EnumRequestProgressTracking } from '@m4u-angular/core/framework/sysenums.enum';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PdfView } from './../views/pdf.view';
@Injectable()
export class PdfEndpoint extends BaseEndpoint
{
    constructor(api: APIGatewayService) {super("Pdf", api);}
	

    public  GetPDFByLink(sLink: string) : Observable<BaseDataResponse<number[]>>
	{
		return this.api.ExecuteGetAction(this.ControllerName, 'GetPDFByLink',  {sLink: sLink} );
    }

    public  GetPDFByPaymentRequestID(iEntryID: number) : Observable<BaseEntityResponse<PdfView>>
	{
		return this.api.ExecuteGetAction(this.ControllerName, 'GetPDFByPaymentRequestID',  {iEntryID: iEntryID} );
    }

    public  GetPDFByLoginRequestID(iEntryID: number) : Observable<BaseEntityResponse<PdfView>>
	{
		return this.api.ExecuteGetAction(this.ControllerName, 'GetPDFByLoginRequestID',  {iEntryID: iEntryID} );
    }
}

